import {
  Box,
  Center,
  Heading,
  Icon,
  Image,
  Text,
  Button,
} from '@chakra-ui/react';
import {
  emphasisButtonProps,
  roundButtonProps,
} from '@inspire/ui/chakra/theme';
import { RightArrowIcon } from '@inspire/ui/icons';

import { sansFonts } from '@inspire/ui/static';
import LinkButton from 'components/general/LinkButton';
import {
  GTM_ACTION_LANDING_PAGE_LYCEEN,
  GTM_ACTION_LANDING_PAGE_PROF,
  GTM_ACTION_LANDING_PAGE_STUDENT,
  GTM_CATEGORY_LANDING_PAGES,
  pushEvent,
} from 'lib/gtm';
import { CONNEXION_PATH, LOGGED_IN_HOME_PATH } from 'lib/paths';
import { accessSSO } from 'lib/sso';
import { useMemoryStore } from 'lib/store';

const Timeline = ({
  timelineContent,
  timelineSubCTA,
  profil,
  ctaUrl = null,
  ctaLabel = null,
}) => {
  // Get the redirect URL from the store for redirection after login
  const redirectTargetUrl = useMemoryStore((s) => s.redirectTargetUrl);
  const redirectUrlFromStore = redirectTargetUrl?.redirectUrl;

  return (
    <>
      <Heading
        as="h3"
        fontSize="3xl"
        mt={0}
        mb={4}
        textAlign="center"
        fontFamily={sansFonts}
      >
        {timelineContent.heading}
      </Heading>
      <Box
        display={{ md: 'flex' }}
        flexWrap="wrap"
        justifyContent="space-around"
      >
        {timelineContent.items.map((i, c) => (
          <Box
            position="relative"
            key={c}
            w={{ base: '100%', md: '40%' }}
            maxW="500px"
            minH={i.minH}
            bgColor="white"
            borderRadius="20px"
            my={[0, null, 3]}
            mx="auto"
            p={4}
            mt="50px !important"
            pb=" 85px !important"
            shadow="md"
          >
            <Box
              pos="absolute"
              m="auto"
              left="0"
              right="0"
              borderRadius="full"
              border="2px solid #A0DCCB"
              bgColor="white"
              top="-2rem"
              boxSize="4rem"
              fontSize={30}
              fontWeight="bold"
              pl="20px"
              pt="6px"
            >
              {c + 1}.
            </Box>
            <Heading
              fontWeight="bold"
              textAlign="center"
              size="md"
              as="h4"
              fontFamily={sansFonts}
              mt={10}
              mb={0}
            >
              {i.title}
            </Heading>
            <Box mt={3}>{i.text}</Box>
            <Image
              src={i.imgURL}
              alt="illustration"
              pos="absolute"
              bottom={5}
              left="50%"
              transform="translate(-50%)"
            />
          </Box>
        ))}
      </Box>
      <Box pos="relative" mt={10}>
        <Center>
          {ctaUrl ? (
            <LinkButton
              href={ctaUrl}
              {...roundButtonProps}
              {...emphasisButtonProps}
            >
              {ctaLabel ? ctaLabel : `S’inscrire`}
            </LinkButton>
          ) : (
            <Button
              {...roundButtonProps}
              {...emphasisButtonProps}
              onClick={() => {
                pushEvent(
                  GTM_CATEGORY_LANDING_PAGES,
                  profil === 'prof'
                    ? GTM_ACTION_LANDING_PAGE_PROF
                    : profil === 'lyceen'
                    ? GTM_ACTION_LANDING_PAGE_LYCEEN
                    : GTM_ACTION_LANDING_PAGE_STUDENT,
                  ctaLabel ? ctaLabel : `S’inscrire`
                );
                accessSSO({
                  targetUrl: redirectUrlFromStore
                    ? `${CONNEXION_PATH}?redirectUrl=${redirectUrlFromStore}`
                    : `${CONNEXION_PATH}?redirectUrl=${LOGGED_IN_HOME_PATH}`,
                });
              }}
            >
              {ctaLabel ? (
                ctaLabel
              ) : (
                <>
                  S’inscrire <Icon ml={2} as={RightArrowIcon} />
                </>
              )}
            </Button>
          )}
        </Center>

        <Text textAlign="center" mt={8} mb={0} maxW="670px" mx="auto">
          {timelineSubCTA}
        </Text>
      </Box>
    </>
  );
};

export default Timeline;
